import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../store/store';
import type { AppDispatch } from '../store/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
